/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Module_Settings_Plc_Maintenance_Not_GeneratedInputs */



/**
* | output |
* | --- |
* | "Not yet generated" |
*
* @param {Module_Settings_Plc_Maintenance_Not_GeneratedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const module_settings_plc_maintenance_not_generated = /** @type {((inputs?: Module_Settings_Plc_Maintenance_Not_GeneratedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Module_Settings_Plc_Maintenance_Not_GeneratedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Not yet generated")
	return /** @type {LocalizedString} */ ("Pas encore généré")
});